// extracted by mini-css-extract-plugin
export var phone = "_2l-0";
export var phoneDragging = "_2l-1";